module.exports = __webpack_public_path__ + "static/media/rec.9c2ab283.png";